<template lang="pug">
#click_heatmap
  .click_heatmap_wrap(:width="page_width",:height="page_height" ref="canvas_y")
  .dot_gradient(v-for="click in clicks", :style="style_gradient(click)", :title="hoverText(click)")
</template>

<script>
import Vue from 'vue'

export default {
  props: {
    token: String,
    state_name: {
      type: String,
      default: "heatmap"
    },
  },
  data(){
    return {
      ctx_y: "",
      ctx_r: "",
    }
  },
  methods: {
    draw(x, y){
      if(x > 0 && y > 0){
        this.$store.dispatch(`${this.state_name}/drawClick`, {
          x: x,
          y: y
        })
      }
    },
    hoverText(click) {
      return `クリック:${click.value}`;
    },
    style_yellow(click){
      return {
        left: click.x - 15 + "px",
        top: click.y - 15 + "px"
      }
    },
    style_gradient(click){
      if(click.x > 0 && click.y > 0){
        return {
          left: click.x - 15 + "px",
          top: click.y - 15 + "px"
        }
      }
    },
    style_orange(click){
      return {
        left: click.x - 10 + "px",
        top: click.y - 10 + "px"
      }
    },
    style_red(click){
      return {
        left: click.x - 5 + "px",
        top: click.y - 5 + "px"
      }
    },
  },
  async mounted(){
    await Vue.nextTick()
    this.$store.commit(`${this.state_name}/setToken`, this.token)
    if (this.$store.state[this.state_name].show_click_heatmap){
      await this.$store.dispatch(`${this.state_name}/getClick`)
    }else{
       this.$store.commit(`${this.state_name}/setClickData`, [])
    }
    
    //var ctx_y = this.$refs.canvas_y.getContext('2d')
    //var ctx_r = this.$refs.canvas_r.getContext('2d')
    //this.$store.commit("heatmap/setCtxY", ctx_y)
    //this.$store.commit("heatmap/setCtxR", ctx_r)
  },
  watch: {
    show_click_heatmap: async function (val) {
      if(val){
        await this.$store.dispatch(`${this.state_name}/getClick`)
      } else {
        this.$store.commit(`${this.state_name}/setClickData`, [])
      }
    },
    click_data: function (val) {
      if(this.show_click_heatmap){
        var clicks = this.$store.getters[`${this.state_name}/clicks`]
        var _self = this
        clicks.forEach(function(click, i){
          //_self.draw(click.x, click.y)
        })
      }
    }
  },
  components: {
  },
  computed: {
    click_heatmap_wrap_style() {
      return {
        height: this.$store.state[this.state_name].page_height + "px",
      }
    },
    show_click_heatmap() {
      return this.$store.state[this.state_name].show_click_heatmap;
    },
    page_width(){
      return this.$store.state[this.state_name].page_width;
    },
    page_height(){
      return this.$store.state[this.state_name].page_height;
    },
    click_data(){
      return this.$store.state[this.state_name].click_data;
    },
    show_click_heatmap(){
      return this.$store.state[this.state_name].show_click_heatmap;
    },
    clicks(){
      return this.$store.getters[`${this.state_name}/clicks`];
    }
  }
}
</script>
<style lang="scss" scoped>

</style>
